import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import HeaderBox from '@/javascript/presentation/components/boxes/header-box'
import Steps from './create/steps/steps'
import ContainerBox from "@/components/shared/boxes/ContainerBox"

const RoutingCreate: React.FC = () => {
  return (
    <Box sx={{ bgcolor: 'background.default' }}>
      <Box sx={{ bgcolor: 'background.header' }}>
        <HeaderBox>
          <Typography variant='h3'>Criar rota</Typography>
        </HeaderBox>
      </Box>
      <Divider />
      <ContainerBox sx={{ display: 'flex', flexDirection: 'column', px: 3, py: 6, gap: 5 }}>
        <Steps />
      </ContainerBox>
    </Box>
  )
}

export default RoutingCreate
